(function () {
  if (window.__pmclineArtisticDropInit) return;
  window.__pmclineArtisticDropInit = true;

  function initCountdown(root) {
    var end = root.getAttribute("data-pad-end");
    if (!end) return;

    var endMs = Date.parse(end);
    if (Number.isNaN(endMs)) return;

    var daysEl = root.querySelector("[data-pad-days]");
    var hoursEl = root.querySelector("[data-pad-hours]");
    var minutesEl = root.querySelector("[data-pad-minutes]");
    var secondsEl = root.querySelector("[data-pad-seconds]");
    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    function pad(n) {
      return String(n).padStart(2, "0");
    }

    function tick() {
      var diff = endMs - Date.now();
      if (diff <= 0) {
        daysEl.textContent = "00";
        hoursEl.textContent = "00";
        minutesEl.textContent = "00";
        secondsEl.textContent = "00";
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      daysEl.textContent = pad(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
    }

    tick();
    setInterval(tick, 1000);
  }

  function initGallery(section) {
    var lightbox = section.querySelector("[data-pad-gallery-lightbox]");
    var lightboxImg = section.querySelector("[data-pad-gallery-lightbox-img]");
    var lightboxStage = section.querySelector("[data-pad-gallery-lightbox-stage]");
    var lightboxCounter = section.querySelector("[data-pad-gallery-counter]");
    var track = section.querySelector("[data-pad-gallery-track]");
    if (!lightbox || !lightboxImg || !lightboxStage) return;

    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }

    var lastFocus = null;
    var dragStartX = 0;
    var dragStartY = 0;
    var didDrag = false;
    var didVerticalDrag = false;
    var slides = [];
    var currentIndex = 0;
    var isAnimating = false;
    var swipe = {
      active: false,
      startX: 0,
      startY: 0,
      deltaX: 0,
      pointerId: null,
      startTime: 0
    };
    var SWIPE_THRESHOLD = 36;
    var SWIPE_VELOCITY = 0.35;

    function collectSlides() {
      var seen = Object.create(null);
      slides = [];

      section.querySelectorAll("[data-pad-gallery-open]").forEach(function (btn) {
        if (btn.closest(".is-color-hidden")) return;
        var src = btn.getAttribute("data-pad-gallery-src");
        if (!src || seen[src]) return;
        seen[src] = true;
        slides.push({
          src: src,
          alt: btn.getAttribute("data-pad-gallery-alt") || ""
        });
      });
    }

    function updateCounter() {
      if (!lightboxCounter) return;
      if (slides.length < 2) {
        lightboxCounter.hidden = true;
        return;
      }
      lightboxCounter.hidden = false;
      lightboxCounter.textContent = currentIndex + 1 + " / " + slides.length;
    }

    function showSlide(index, direction) {
      if (!slides.length || isAnimating) return;

      var nextIndex = ((index % slides.length) + slides.length) % slides.length;
      var slide = slides[nextIndex];
      var dir = direction || 0;

      if (!dir) {
        currentIndex = nextIndex;
        lightboxImg.src = slide.src;
        lightboxImg.alt = slide.alt;
        lightboxImg.style.opacity = "1";
        lightboxImg.style.transform = "translateX(0)";
        updateCounter();
        return;
      }

      isAnimating = true;
      lightboxImg.style.transition = "transform 0.28s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.22s ease";
      lightboxImg.style.transform = "translateX(" + -dir * 28 + "%)";
      lightboxImg.style.opacity = "0";

      window.setTimeout(function () {
        currentIndex = nextIndex;
        lightboxImg.style.transition = "none";
        lightboxImg.src = slide.src;
        lightboxImg.alt = slide.alt;
        lightboxImg.style.transform = "translateX(" + dir * 28 + "%)";
        updateCounter();

        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            lightboxImg.style.transition =
              "transform 0.32s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.28s ease";
            lightboxImg.style.transform = "translateX(0)";
            lightboxImg.style.opacity = "1";
            window.setTimeout(function () {
              isAnimating = false;
              lightboxImg.style.transition = "";
            }, 320);
          });
        });
      }, 180);
    }

    function resetSwipeTransform() {
      lightboxImg.style.transition = "transform 0.28s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.2s ease";
      lightboxImg.style.transform = "translateX(0)";
      lightboxImg.style.opacity = "1";
      lightboxStage.classList.remove("is-dragging");
    }

    function goToNextSlide() {
      showSlide(currentIndex + 1, 1);
    }

    function goToPrevSlide() {
      showSlide(currentIndex - 1, -1);
    }

    function initInfiniteTrack(trackEl) {
      if (!trackEl) return;

      var looping = false;
      var mobileQuery = window.matchMedia("(max-width: 1099px)");
      var prevInlineBtn = section.querySelector("[data-pad-gallery-inline-prev]");
      var nextInlineBtn = section.querySelector("[data-pad-gallery-inline-next]");
      var thumbsRoot = section.querySelector("[data-pad-gallery-thumbs]");
      var thumbButtons = thumbsRoot
        ? Array.prototype.slice.call(thumbsRoot.querySelectorAll("[data-pad-gallery-thumb]"))
        : [];
      var uniqueCount = thumbButtons.length;

      function refreshVisibleThumbs() {
        thumbButtons = thumbsRoot
          ? Array.prototype.slice.call(
              thumbsRoot.querySelectorAll("[data-pad-gallery-thumb]:not(.is-color-hidden)")
            )
          : [];
        uniqueCount = thumbButtons.length;
        thumbButtons.forEach(function (btn, i) {
          btn.setAttribute("data-pad-gallery-thumb-index", String(i));
        });
      }

      section._padRefreshThumbs = refreshVisibleThumbs;

      function halfWidth() {
        return trackEl.scrollWidth / 2;
      }

      function visibleSlideItems() {
        return Array.prototype.slice.call(
          trackEl.querySelectorAll(".pad__gallery-item:not(.is-color-hidden)")
        );
      }

      function slideWidth() {
        var items = visibleSlideItems();
        var item = items[0] || trackEl.querySelector(".pad__gallery-item");
        return item ? item.getBoundingClientRect().width : trackEl.clientWidth;
      }

      function currentSlideIndex() {
        var items = visibleSlideItems();
        if (!items.length) return 0;
        var left = trackEl.scrollLeft;
        var best = 0;
        var bestDist = Infinity;
        items.forEach(function (item, i) {
          var dist = Math.abs(item.offsetLeft - left);
          if (dist < bestDist) {
            bestDist = dist;
            best = i;
          }
        });
        return best;
      }

      function setActiveThumb(index) {
        refreshVisibleThumbs();
        if (!uniqueCount) return;
        var safe = ((index % uniqueCount) + uniqueCount) % uniqueCount;
        thumbButtons.forEach(function (btn, i) {
          btn.classList.toggle("is-active", i === safe);
        });
        var active = thumbButtons[safe];
        if (active && active.scrollIntoView) {
          active.scrollIntoView({
            behavior: "smooth",
            inline: "nearest",
            block: "nearest"
          });
        }
      }

      function syncThumbsFromScroll() {
        if (!uniqueCount && thumbsRoot) refreshVisibleThumbs();
        if (!uniqueCount) return;
        setActiveThumb(currentSlideIndex());
      }

      function scrollToIndex(index) {
        refreshVisibleThumbs();
        if (!uniqueCount) return;
        var safe = ((index % uniqueCount) + uniqueCount) % uniqueCount;
        var items = visibleSlideItems();
        var target = items[safe];
        if (!target) return;
        trackEl.scrollTo({ left: target.offsetLeft, behavior: "smooth" });
        setActiveThumb(safe);
      }

      section._padScrollToIndex = scrollToIndex;

      function normalizeLoop() {
        if (section.hasAttribute("data-pad-gallery-noloop")) return;
        if (!mobileQuery.matches || looping) return;
        var half = halfWidth();
        if (half < 8) return;

        if (trackEl.scrollLeft >= half) {
          looping = true;
          trackEl.scrollLeft = trackEl.scrollLeft - half;
          looping = false;
        }
      }

      trackEl.addEventListener(
        "scroll",
        function () {
          didDrag = true;
          normalizeLoop();
          syncThumbsFromScroll();
        },
        { passive: true }
      );

      if (thumbsRoot) {
        thumbsRoot.addEventListener("click", function (event) {
          var btn = event.target.closest("[data-pad-gallery-thumb]");
          if (!btn || !thumbsRoot.contains(btn) || btn.classList.contains("is-color-hidden")) {
            return;
          }
          var index = parseInt(btn.getAttribute("data-pad-gallery-thumb-index"), 10);
          if (Number.isNaN(index)) return;
          scrollToIndex(index);
        });
        syncThumbsFromScroll();
      }

      if (prevInlineBtn) {
        prevInlineBtn.addEventListener("click", function () {
          refreshVisibleThumbs();
          if (!uniqueCount) return;
          scrollToIndex(currentSlideIndex() - 1);
        });
      }

      if (nextInlineBtn) {
        nextInlineBtn.addEventListener("click", function () {
          refreshVisibleThumbs();
          if (!uniqueCount) return;
          scrollToIndex(currentSlideIndex() + 1);
        });
      }
    }

    if (track) {
      track.addEventListener(
        "pointerdown",
        function (event) {
          didDrag = false;
          didVerticalDrag = false;
          dragStartX = event.clientX;
          dragStartY = event.clientY;
        },
        { passive: true }
      );

      track.addEventListener(
        "pointermove",
        function (event) {
          var deltaX = Math.abs(event.clientX - dragStartX);
          var deltaY = Math.abs(event.clientY - dragStartY);

          if (deltaY > deltaX && deltaY > 8) {
            didVerticalDrag = true;
          }

          if (deltaX > 8 || deltaY > 8) {
            didDrag = true;
          }
        },
        { passive: true }
      );

      initInfiniteTrack(track);
    }

    function closeLightbox() {
      lightbox.hidden = true;
      document.body.classList.remove("pad--lightbox-open");
      lightboxImg.removeAttribute("src");
      resetSwipeTransform();
      swipe.active = false;
      isAnimating = false;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function openLightbox(btn, startIndex) {
      collectSlides();
      if (!slides.length) return;

      var src = btn ? btn.getAttribute("data-pad-gallery-src") : "";
      var index =
        typeof startIndex === "number"
          ? startIndex
          : slides.findIndex(function (slide) {
              return slide.src === src;
            });

      lastFocus = btn || lastFocus;
      currentIndex = index >= 0 ? index : 0;
      isAnimating = false;
      showSlide(currentIndex, 0);
      lightbox.hidden = false;
      document.body.classList.add("pad--lightbox-open");
      var closeBtn = lightbox.querySelector(".pad__gallery-lightbox-close");
      if (closeBtn) closeBtn.focus();
    }

    lightboxStage.addEventListener("dragstart", function (event) {
      event.preventDefault();
    });

    lightboxStage.addEventListener("pointerdown", function (event) {
      if (lightbox.hidden || slides.length < 2 || isAnimating) return;
      if (event.pointerType === "mouse" && event.button !== 0) return;
      if (event.target.closest("[data-pad-gallery-prev], [data-pad-gallery-next], [data-pad-gallery-close]")) {
        return;
      }

      swipe.active = true;
      swipe.startX = event.clientX;
      swipe.startY = event.clientY;
      swipe.deltaX = 0;
      swipe.pointerId = event.pointerId;
      swipe.startTime = Date.now();
      lightboxStage.classList.add("is-dragging");
      lightboxImg.style.transition = "none";

      if (lightboxStage.setPointerCapture) {
        lightboxStage.setPointerCapture(event.pointerId);
      }
    });

    lightboxStage.addEventListener("pointermove", function (event) {
      if (!swipe.active || event.pointerId !== swipe.pointerId) return;

      swipe.deltaX = event.clientX - swipe.startX;
      var deltaY = event.clientY - swipe.startY;

      if (Math.abs(deltaY) > Math.abs(swipe.deltaX) && Math.abs(swipe.deltaX) < 10) {
        return;
      }

      event.preventDefault();
      var resistance = 1;
      lightboxImg.style.transform = "translateX(" + swipe.deltaX * resistance + "px)";
      lightboxImg.style.opacity = String(Math.max(0.45, 1 - Math.abs(swipe.deltaX) / 420));
    });

    function finishSwipe(event) {
      if (!swipe.active || (event && event.pointerId !== swipe.pointerId)) return;

      swipe.active = false;
      lightboxStage.classList.remove("is-dragging");

      if (lightboxStage.releasePointerCapture && event) {
        try {
          lightboxStage.releasePointerCapture(event.pointerId);
        } catch (err) {
          /* ignore */
        }
      }

      var elapsed = Math.max(Date.now() - swipe.startTime, 1);
      var velocity = Math.abs(swipe.deltaX) / elapsed;
      var shouldChange =
        Math.abs(swipe.deltaX) >= SWIPE_THRESHOLD || velocity >= SWIPE_VELOCITY;

      if (shouldChange) {
        if (swipe.deltaX < 0) {
          goToNextSlide();
        } else {
          goToPrevSlide();
        }
      } else {
        resetSwipeTransform();
      }

      swipe.deltaX = 0;
    }

    function handleGalleryClick(event) {
      if (event.target.closest("[data-pad-gallery-prev]")) {
        event.preventDefault();
        goToPrevSlide();
        return;
      }
      if (event.target.closest("[data-pad-gallery-next]")) {
        event.preventDefault();
        goToNextSlide();
        return;
      }

      var openBtn = event.target.closest("[data-pad-gallery-open]");
      if (openBtn && section.contains(openBtn)) {
        if (didDrag || didVerticalDrag) {
          didDrag = false;
          didVerticalDrag = false;
          return;
        }
        event.preventDefault();
        openLightbox(openBtn);
        return;
      }

      if (event.target.closest("[data-pad-gallery-close]")) {
        event.preventDefault();
        closeLightbox();
      }
    }

    lightboxStage.addEventListener("pointerup", finishSwipe);
    lightboxStage.addEventListener("pointercancel", finishSwipe);

    section.addEventListener("click", handleGalleryClick);
    lightbox.addEventListener("click", handleGalleryClick);

    document.addEventListener("keydown", function (event) {
      if (lightbox.hidden) return;
      if (event.key === "Escape") {
        closeLightbox();
        return;
      }
      if (slides.length < 2) return;
      if (event.key === "ArrowRight") {
        event.preventDefault();
        goToNextSlide();
      }
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        goToPrevSlide();
      }
    });

    section.__padOpenLightbox = openLightbox;
  }

  var productCache = Object.create(null);

  function isEuropeanAmount(text) {
    var ref = (text || "").replace(/\s/g, "");
    return /,\d{1,2}$/.test(ref) && (ref.indexOf(".") === -1 || ref.lastIndexOf(",") > ref.lastIndexOf("."));
  }

  function parsePadAmountToCents(text) {
    var ref = (text || "").replace(/[^\d,.-]/g, "").trim();
    if (!ref) return 0;
    var amount;
    if (isEuropeanAmount(ref)) {
      amount = parseFloat(ref.replace(/\./g, "").replace(",", "."));
    } else {
      amount = parseFloat(ref.replace(/,/g, ""));
    }
    if (!Number.isFinite(amount)) return 0;
    return Math.round(amount * 100);
  }

  function formatPadAmount(cents, referenceText) {
    var value = cents / 100;
    var locale = isEuropeanAmount(referenceText) ? "fr-FR" : "en-US";
    var hasDecimals = Math.round(value * 100) % 100 !== 0;
    return value.toLocaleString(locale, {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  function getPadCurrencySymbol(code, referenceText) {
    if (!code) return "";
    var symbolMap = {
      AED: "د.إ",
      EUR: "€",
      USD: "$",
      GBP: "£",
      CHF: "CHF",
      CAD: "$",
      AUD: "$",
      NZD: "$",
      JPY: "¥",
      CNY: "¥",
      HKD: "$",
      SGD: "$"
    };
    if (symbolMap[code]) return symbolMap[code];
    var locale = isEuropeanAmount(referenceText) ? "fr-FR" : "en-US";
    try {
      var parts = new Intl.NumberFormat(locale, {
        style: "currency",
        currency: code,
        currencyDisplay: "narrowSymbol",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).formatToParts(0);
      var currencyPart = parts.find(function (part) {
        return part.type === "currency";
      });
      return currencyPart ? currencyPart.value : code;
    } catch (error) {
      return code;
    }
  }

  function getShopProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch("/products/" + handle + ".js")
      .then(function (res) {
        if (!res.ok) throw new Error("product.js " + res.status);
        return res.json();
      })
      .catch(function () {
        delete productCache[handle];
        return null;
      });
    return productCache[handle];
  }

  function syncPadPrices(root) {
    if (root.getAttribute("data-pad-js-compare") !== "1") return Promise.resolve();
    if (root.querySelector("[data-pad-compare-static]")) return Promise.resolve();

    var handle = root.getAttribute("data-pad-product-handle");
    var variantId = Number(root.getAttribute("data-pad-variant-id"));
    var presentmentPrice = Number(root.getAttribute("data-pad-presentment-price"));
    var shopPriceAttr = Number(root.getAttribute("data-pad-shop-price-cents"));
    var shopCompareAttr = Number(root.getAttribute("data-pad-shop-compare-cents"));
    var saleAmount = root.querySelector("[data-pad-sale-amount]");
    var compareEl = root.querySelector("[data-pad-compare-price]");
    if (!saleAmount || !compareEl) return Promise.resolve();

    function applyCompare(amountText, saleCents, compareCents) {
      if (!amountText) return;
      var compareAmount = compareEl.querySelector("[data-pad-compare-amount]");
      if (!compareAmount) return;
      compareAmount.textContent = amountText;
      compareEl.removeAttribute("hidden");
      compareEl.classList.add("is-visible");
      compareEl.setAttribute("data-pad-compare-ready", "");

      var discountEl = compareEl.querySelector("[data-pad-discount]");
      if (!discountEl) {
        discountEl = document.createElement("sup");
        discountEl.className = "pad__acquire-discount";
        discountEl.setAttribute("data-pad-discount", "");
        compareEl.appendChild(discountEl);
      }
      if (saleCents > 0 && compareCents > saleCents) {
        var pct = Math.round(((compareCents - saleCents) / compareCents) * 100);
        if (pct > 0) {
          discountEl.textContent = "-" + pct + "%";
          discountEl.classList.remove("is-empty");
          discountEl.removeAttribute("hidden");
        } else {
          discountEl.textContent = "";
          discountEl.classList.add("is-empty");
          discountEl.setAttribute("hidden", "");
        }
      }
    }

    function hideCompare() {
      compareEl.removeAttribute("data-pad-compare-ready");
      compareEl.classList.remove("is-visible");
      compareEl.setAttribute("hidden", "");
      var compareAmount = compareEl.querySelector("[data-pad-compare-amount]");
      if (compareAmount) compareAmount.textContent = "";
      var discountEl = compareEl.querySelector("[data-pad-discount]");
      if (discountEl) {
        discountEl.textContent = "";
        discountEl.classList.add("is-empty");
        discountEl.setAttribute("hidden", "");
      }
    }

    function tryApplyFromShop(shopPrice, shopCompare, saleCents, saleText) {
      if (!shopPrice || !shopCompare || shopCompare <= shopPrice || !saleCents) return false;
      var convertedCompare = Math.round(shopCompare * (saleCents / shopPrice));
      if (!convertedCompare || convertedCompare <= saleCents) return false;
      applyCompare(formatPadAmount(convertedCompare, saleText), saleCents, convertedCompare);
      return true;
    }

    var saleText = (saleAmount.textContent || "").replace(/\s+/g, " ").trim();
    var saleCents = parsePadAmountToCents(saleText);
    if (!saleCents && presentmentPrice > 0) saleCents = presentmentPrice;
    if (!saleCents || saleCents <= 0) return Promise.resolve();

    if (tryApplyFromShop(shopPriceAttr, shopCompareAttr, saleCents, saleText)) {
      return Promise.resolve();
    }

    if (!handle) return Promise.resolve();

    return getShopProduct(handle).then(function (product) {
      if (!product || !product.variants) return;
      var variant =
        product.variants.find(function (v) {
          return Number(v.id) === variantId;
        }) || product.variants[0];
      if (!variant) {
        hideCompare();
        return;
      }

      var shopPrice = shopPriceAttr > 0 ? shopPriceAttr : Number(variant.price);
      var shopCompare =
        shopCompareAttr > 0 ? shopCompareAttr : Number(variant.compare_at_price);
      if (!tryApplyFromShop(shopPrice, shopCompare, saleCents, saleText)) {
        hideCompare();
      }
    });
  }

  function syncPadCurrencySymbols(root) {
    var code = root.getAttribute("data-pad-currency-code");
    if (!code) return;
    var referenceText = "";
    var saleAmount = root.querySelector("[data-pad-sale-amount]");
    if (saleAmount) {
      // Shopify money_without_currency laisse souvent un NBSP / espace fine en fin
      saleAmount.textContent = String(saleAmount.textContent || "").replace(
        /[\s\u00a0\u202f\u2009]+$/g,
        ""
      );
      referenceText = saleAmount.textContent;
    }
    root.querySelectorAll("[data-pad-compare-amount]").forEach(function (el) {
      el.textContent = String(el.textContent || "").replace(
        /[\s\u00a0\u202f\u2009]+$/g,
        ""
      );
    });
    var symbol = getPadCurrencySymbol(code, referenceText);
    root.querySelectorAll("[data-pad-currency-symbol]").forEach(function (el) {
      el.textContent = symbol || code;
    });
  }

  function initPadPrices(root) {
    syncPadCurrencySymbols(root);
    if (root.getAttribute("data-pad-js-compare") !== "1") return;
    if (root.querySelector("[data-pad-compare-static]")) return;
    syncPadPrices(root);
    setTimeout(function () {
      syncPadCurrencySymbols(root);
      syncPadPrices(root);
    }, 500);
  }

  function syncCountdownsFromHero() {
    var hero = document.querySelector(".pad__hero [data-pad-countdown]");
    if (!hero) return;

    var end = hero.getAttribute("data-pad-end");
    if (!end) return;

    var heroLabels = hero.querySelectorAll(".pad__countdown-label");

    document.querySelectorAll("[data-pad-sync-from-hero]").forEach(function (el) {
      el.setAttribute("data-pad-end", end);

      var labels = el.querySelectorAll(".pad__countdown-label");
      heroLabels.forEach(function (label, index) {
        if (labels[index]) labels[index].textContent = label.textContent;
      });
    });
  }

  syncCountdownsFromHero();
  document.querySelectorAll("[data-pad-countdown]").forEach(initCountdown);
  document.querySelectorAll("[data-pad-gallery]").forEach(initGallery);
  document.querySelectorAll("[data-pad-prices]").forEach(initPadPrices);

  function initStickyCta(root) {
    var dock = root.querySelector("[data-pad-sticky-dock]");
    var heroForm = root.querySelector("#pad-hero-form");
    var stickyBtn = root.querySelector("[data-pad-sticky-submit]");
    var mobileHeroBtn = root.querySelector("[data-pad-mobile-hero-submit]");
    if (!dock || !heroForm) return;

    function submitHeroForm() {
      var submit = heroForm.querySelector(".pad__btn-acquire");
      if (submit) submit.click();
    }

    function syncStickyVisibility() {
      if (window.innerWidth >= 1100) {
        dock.hidden = true;
        root.classList.remove("pad--sticky-active");
        return;
      }

      dock.hidden = false;
      root.classList.add("pad--sticky-active");
    }

    if (stickyBtn) {
      stickyBtn.addEventListener("click", submitHeroForm);
    }

    if (mobileHeroBtn) {
      mobileHeroBtn.addEventListener("click", submitHeroForm);
    }

    window.addEventListener("scroll", syncStickyVisibility, { passive: true });
    window.addEventListener("resize", syncStickyVisibility);
    syncStickyVisibility();
  }

  function initGalleryFullscreen(section) {
    var btn = section.querySelector("[data-pad-gallery-fullscreen]");
    if (!btn) return;
    btn.addEventListener("click", function () {
      if (typeof section.__padOpenLightbox === "function") {
        section.__padOpenLightbox(null, 0);
        return;
      }
      var firstOpen = section.querySelector("[data-pad-gallery-open]");
      if (firstOpen) firstOpen.click();
    });
  }

  function initCollapsibleText(section) {
    var body = section.querySelector("[data-pad-collapsible-body]");
    var toggle = section.querySelector("[data-pad-collapsible-toggle]");
    if (!body || !toggle) return;

    var gridSection = section.closest(".pad__964y-grid");
    var seeMoreLabel = (gridSection && gridSection.getAttribute("data-pad-see-more")) || "See more";
    var seeLessLabel = (gridSection && gridSection.getAttribute("data-pad-see-less")) || "See less";

    function syncToggleVisibility() {
      var shouldCollapse = window.innerWidth >= 1100 && body.scrollHeight > body.clientHeight + 8;
      toggle.hidden = !shouldCollapse && !body.classList.contains("is-expanded");
      if (!shouldCollapse && !body.classList.contains("is-expanded")) {
        toggle.setAttribute("aria-expanded", "false");
        toggle.textContent = seeMoreLabel;
      }
    }

    toggle.hidden = false;
    syncToggleVisibility();

    toggle.addEventListener("click", function () {
      var expanded = body.classList.toggle("is-expanded");
      toggle.setAttribute("aria-expanded", expanded ? "true" : "false");
      toggle.textContent = expanded ? seeLessLabel : seeMoreLabel;
      syncToggleVisibility();
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth < 1100) {
        body.classList.remove("is-expanded");
        toggle.setAttribute("aria-expanded", "false");
        toggle.textContent = seeMoreLabel;
      }
      syncToggleVisibility();
    });
  }

  function g63GalleryViewIndex(el) {
    var open = el.querySelector("[data-pad-gallery-alt]");
    var alt =
      (open && open.getAttribute("data-pad-gallery-alt")) ||
      el.getAttribute("aria-label") ||
      "";
    var match = String(alt).match(/view\s*(\d+)/i);
    return match ? parseInt(match[1], 10) : 999;
  }

  function reorderG63GalleryForColor(gallery, color) {
    var track = gallery.querySelector("[data-pad-gallery-track]");
    var thumbsRoot = gallery.querySelector("[data-pad-gallery-thumbs]");

    function sortContainer(container, selector) {
      if (!container) return;
      var items = Array.prototype.slice.call(container.querySelectorAll(selector));
      if (!items.length) return;
      var visible = items.filter(function (el) {
        return el.getAttribute("data-pad-color") === color;
      });
      var hidden = items.filter(function (el) {
        return el.getAttribute("data-pad-color") !== color;
      });
      visible.sort(function (a, b) {
        return g63GalleryViewIndex(a) - g63GalleryViewIndex(b);
      });
      visible.concat(hidden).forEach(function (el) {
        container.appendChild(el);
      });
    }

    sortContainer(track, ".pad__gallery-item");
    sortContainer(thumbsRoot, "[data-pad-gallery-thumb]");
  }

  function filterG63GalleriesByColor(color) {
    if (!color) return;
    document.querySelectorAll('[data-pad-template="drop-g63"]').forEach(function (pad) {
      pad.classList.toggle("is-g63-gallery-white", color === "White");
    });
    document.querySelectorAll("[data-pad-gallery]").forEach(function (gallery) {
      var colored = gallery.querySelectorAll("[data-pad-color]");
      if (!colored.length) return;

      colored.forEach(function (el) {
        var match = el.getAttribute("data-pad-color") === color;
        el.classList.toggle("is-color-hidden", !match);
      });

      reorderG63GalleryForColor(gallery, color);

      if (typeof gallery._padRefreshThumbs === "function") {
        gallery._padRefreshThumbs();
      }

      var visibleThumbs = gallery.querySelectorAll(
        "[data-pad-gallery-thumb]:not(.is-color-hidden)"
      );
      visibleThumbs.forEach(function (btn, i) {
        btn.classList.toggle("is-active", i === 0);
      });

      var track = gallery.querySelector("[data-pad-gallery-track]");
      if (track) track.scrollLeft = 0;
      if (typeof gallery._padScrollToIndex === "function") {
        gallery._padScrollToIndex(0);
      }
    });
  }

  function initG63DropOptions() {
    var roots = Array.prototype.slice.call(
      document.querySelectorAll("[data-pad-g63-options]")
    );
    if (!roots.length) return;

    var productId = roots[0].getAttribute("data-pad-g63-product-id") || "";
    var productHandle = roots[0].getAttribute("data-pad-g63-handle") || "";
    var totalPieces = Number(roots[0].getAttribute("data-pad-g63-total")) || 100;
    var alreadyInCart = false;

    function isVisible(el) {
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    }

    function getFormKey(root) {
      var namedWithForm = root.querySelector("[name][form]");
      if (namedWithForm) return namedWithForm.getAttribute("form") || "form";
      var form = root.closest("form");
      if (form) return form.id || "inline-form";
      return "none";
    }

    function getActiveRootFor(root) {
      var key = getFormKey(root);
      var group = roots.filter(function (block) {
        return getFormKey(block) === key;
      });
      for (var i = 0; i < group.length; i++) {
        if (isVisible(group[i])) return group[i];
      }
      return group[0] || root;
    }

    function getActiveRoot() {
      return getActiveRootFor(roots[0]);
    }

    function selectedPieceOption(pieceSelect) {
      if (!pieceSelect) return null;
      return pieceSelect.options[pieceSelect.selectedIndex] || null;
    }

    function cartHasG63(cart) {
      var items = (cart && cart.items) || [];
      for (var i = 0; i < items.length; i++) {
        if (productId && String(items[i].product_id) === String(productId)) return true;
      }
      return false;
    }

    function collectG63Forms() {
      var forms = [];
      var seen = {};
      roots.forEach(function (root) {
        var formAttr = root.querySelector("[name][form]");
        var formId = formAttr ? formAttr.getAttribute("form") : "";
        var form = formId
          ? document.getElementById(formId)
          : root.closest("form");
        if (!form || seen[form.id || form]) return;
        seen[form.id || form] = true;
        forms.push(form);
      });
      var heroForm = document.getElementById("pad-hero-form");
      if (heroForm && !seen[heroForm.id || heroForm]) forms.push(heroForm);
      return forms;
    }

    function setAlreadyInCartUI(locked) {
      alreadyInCart = !!locked;
      roots.forEach(function (root) {
        var msg = root.querySelector("[data-pad-g63-cart-msg]");
        if (msg) msg.hidden = !locked;
      });
      collectG63Forms().forEach(function (form) {
        form.querySelectorAll('.pad__btn-acquire[type="submit"]').forEach(function (btn) {
          btn.disabled = locked || btn.hasAttribute("data-pad-g63-sold");
          if (locked) {
            if (!btn.getAttribute("data-pad-g63-label")) {
              btn.setAttribute("data-pad-g63-label", btn.textContent.trim());
            }
            btn.textContent = "ALREADY IN CART";
          } else if (btn.getAttribute("data-pad-g63-label")) {
            btn.textContent = btn.getAttribute("data-pad-g63-label");
          }
        });
      });
      document.querySelectorAll("[data-pad-sticky-submit], [data-pad-mobile-hero-submit]").forEach(function (btn) {
        btn.disabled = locked;
        if (locked) {
          if (!btn.getAttribute("data-pad-g63-label")) {
            var label = btn.querySelector(".pad__btn-acquire-label") || btn;
            btn.setAttribute("data-pad-g63-label", label.textContent.trim());
          }
          var labelEl = btn.querySelector(".pad__btn-acquire-label");
          if (labelEl) labelEl.textContent = "ALREADY IN CART";
          else btn.textContent = "ALREADY IN CART";
        } else if (btn.getAttribute("data-pad-g63-label")) {
          var restore = btn.getAttribute("data-pad-g63-label");
          var labelRestore = btn.querySelector(".pad__btn-acquire-label");
          if (labelRestore) labelRestore.textContent = restore;
          else btn.textContent = restore;
        }
      });
    }

    function fetchCart() {
      return fetch("/cart.js", { credentials: "same-origin", headers: { Accept: "application/json" } }).then(
        function (res) {
          if (!res.ok) throw new Error("cart");
          return res.json();
        }
      );
    }

    function refreshCartGate() {
      return fetchCart()
        .then(function (cart) {
          setAlreadyInCartUI(cartHasG63(cart));
          return cart;
        })
        .catch(function () {
          return null;
        });
    }

    function syncOrderProperties(sourceRoot) {
      var root = sourceRoot || getActiveRoot();
      if (!root) return;
      var colorSelect = root.querySelector("[data-pad-g63-color]");
      var pieceSelect = root.querySelector("[data-pad-g63-piece]");
      var opt = selectedPieceOption(pieceSelect);
      var color = colorSelect && colorSelect.value ? colorSelect.value : "Black";
      var piece = opt && opt.getAttribute("data-pad-status") === "available" ? String(opt.value) : "";
      var variantId = opt && opt.getAttribute("data-pad-variant-id") ? opt.getAttribute("data-pad-variant-id") : "";

      roots.forEach(function (block) {
        var blockColor = block.querySelector("[data-pad-g63-color]");
        var blockPiece = block.querySelector("[data-pad-g63-piece]");
        var blockColorValue = block.querySelector("[data-pad-g63-color-value]");
        var blockPieceValue = block.querySelector("[data-pad-g63-piece-value]");
        var blockDescription = block.querySelector("[data-pad-g63-description]");
        var blockQty = block.querySelector("[data-pad-g63-quantity]");
        var blockVariant = block.querySelector("[data-pad-g63-variant-id]");
        if (blockColor && color) blockColor.value = color;
        if (blockPiece && piece) blockPiece.value = piece;
        if (blockColorValue) blockColorValue.value = color;
        if (blockPieceValue && piece) blockPieceValue.value = piece;
        if (blockDescription && piece) {
          blockDescription.value = "Piece #" + piece + " — " + color;
        }
        if (blockQty) blockQty.value = "1";
        if (blockVariant && variantId) {
          blockVariant.value = variantId;
          block.setAttribute("data-pad-g63-variant-id", variantId);
        }
      });

      // Formulaire d'achat : l'input name="id" vit hors des blocs options
      // (include_variant_id:false). Sans ça, le panier garde la 1re variante dispo (#5).
      if (variantId) {
        document
          .querySelectorAll('input[name="id"][data-pad-g63-variant-id]')
          .forEach(function (input) {
            input.value = variantId;
          });
      }

      filterG63GalleriesByColor(color);
    }

    function rebuildPieceSelectFromProduct(product) {
      var list = (product && product.variants) || [];
      if (!list.length) return;
      var sold = [];
      var avail = [];
      list.forEach(function (v) {
        var n = parseInt(String(v.option1 || v.title || "").replace(/[^\d]/g, ""), 10);
        if (!Number.isFinite(n) || n < 1) return;
        var available =
          v.available === true ||
          (typeof v.inventory_quantity === "number" && v.inventory_quantity > 0);
        var row = { n: n, id: v.id, available: available };
        if (available) avail.push(row);
        else sold.push(row);
      });
      sold.sort(function (a, b) {
        return a.n - b.n;
      });
      avail.sort(function (a, b) {
        return a.n - b.n;
      });
      var remaining = avail.length;
      var defaultPiece = avail.length ? avail[0].n : 0;

      roots.forEach(function (root) {
        root.setAttribute("data-pad-g63-remaining", String(remaining));
        var pieceSelect = root.querySelector("[data-pad-g63-piece]");
        var hint = root.querySelector(".pad__drop-hint:not(.pad__drop-hint--cart)");
        if (!pieceSelect) return;
        var current = pieceSelect.value;
        pieceSelect.innerHTML = "";
        sold.forEach(function (row) {
          var opt = document.createElement("option");
          opt.value = String(row.n);
          opt.textContent = "#" + row.n + " - Sold";
          opt.disabled = true;
          opt.setAttribute("data-pad-status", "sold");
          opt.setAttribute("data-pad-variant-id", String(row.id));
          pieceSelect.appendChild(opt);
        });
        avail.forEach(function (row) {
          var opt = document.createElement("option");
          opt.value = String(row.n);
          opt.textContent = "#" + row.n + " - Available";
          opt.setAttribute("data-pad-status", "available");
          opt.setAttribute("data-pad-variant-id", String(row.id));
          pieceSelect.appendChild(opt);
        });
        var keep = avail.some(function (row) {
          return String(row.n) === String(current);
        });
        if (keep) pieceSelect.value = String(current);
        else if (defaultPiece) pieceSelect.value = String(defaultPiece);
        if (hint) {
          if (!remaining) {
            hint.innerHTML = "Sold out — all 100 pieces have been claimed.";
          } else {
            hint.innerHTML =
              "Shared stock: <strong>" +
              remaining +
              "</strong> / " +
              totalPieces +
              " left. Choose any available number.";
          }
        }
      });
    }

    function refreshPieceFromLiveInventory() {
      if (!productHandle) return Promise.resolve();
      return fetch("/products/" + encodeURIComponent(productHandle) + ".js", {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      })
        .then(function (res) {
          if (!res.ok) throw new Error("product");
          return res.json();
        })
        .then(function (product) {
          rebuildPieceSelectFromProduct(product);
          syncOrderProperties(getActiveRoot());
        })
        .catch(function () {
          return null;
        });
    }

    function refreshNamedFields() {
      var seen = {};
      roots.forEach(function (root) {
        var key = getFormKey(root);
        if (seen[key]) return;
        seen[key] = true;
        var group = roots.filter(function (block) {
          return getFormKey(block) === key;
        });
        var active = null;
        for (var i = 0; i < group.length; i++) {
          if (isVisible(group[i])) {
            active = group[i];
            break;
          }
        }
        if (!active) active = group[0];
        group.forEach(function (block) {
          var on = block === active;
          block.querySelectorAll("[name]").forEach(function (el) {
            el.disabled = on
              ? el.getAttribute("data-pad-g63-locked") === "1"
              : true;
          });
        });
      });
    }

    roots.forEach(function (root) {
      var colorSelect = root.querySelector("[data-pad-g63-color]");
      var pieceSelect = root.querySelector("[data-pad-g63-piece]");

      if (pieceSelect) {
        pieceSelect.addEventListener("change", function () {
          var opt = selectedPieceOption(pieceSelect);
          if (!opt || opt.getAttribute("data-pad-status") !== "available") {
            var firstAvail = Array.prototype.find.call(pieceSelect.options, function (o) {
              return o.getAttribute("data-pad-status") === "available";
            });
            if (firstAvail) pieceSelect.value = firstAvail.value;
          }
          syncOrderProperties(root);
        });
      }

      if (colorSelect) {
        colorSelect.addEventListener("change", function () {
          syncOrderProperties(root);
        });
      }

      var formAttr = root.querySelector("[name][form]");
      var formId = formAttr ? formAttr.getAttribute("form") : "";
      var form = formId
        ? document.getElementById(formId)
        : root.closest("form");
      if (form && !form._padG63SubmitBound) {
        form._padG63SubmitBound = true;
        form.addEventListener("submit", function (event) {
          event.preventDefault();
          if (alreadyInCart) {
            setAlreadyInCartUI(true);
            return;
          }
          refreshNamedFields();
          syncOrderProperties(getActiveRoot());
          var submitting = form;
          fetchCart()
            .then(function (cart) {
              if (cartHasG63(cart)) {
                setAlreadyInCartUI(true);
                return;
              }
              HTMLFormElement.prototype.submit.call(submitting);
            })
            .catch(function () {
              HTMLFormElement.prototype.submit.call(submitting);
            });
        });
      }
    });

    refreshNamedFields();
    syncOrderProperties(getActiveRoot());
    refreshPieceFromLiveInventory();
    refreshCartGate();
    window.addEventListener("resize", refreshNamedFields);
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") {
        refreshCartGate();
        refreshPieceFromLiveInventory();
      }
    });
  }

  initG63DropOptions();

  document.querySelectorAll('[data-pad-template^="drop-964"], [data-pad-template="drop-aventador"], [data-pad-template="drop-testarossa"], [data-pad-template="drop-miura"], [data-pad-template="drop-evo-2"], [data-pad-template="drop-g63"]').forEach(initStickyCta);
  document.querySelectorAll("[data-pad-gallery]").forEach(initGalleryFullscreen);
  document.querySelectorAll(".pad__964y-col--sculpture").forEach(initCollapsibleText);
})();
